/*
 *  Document   : client-mission-index.js
 *  Author     : Exapoint
 *
 */

// Import required modules

// Tools

import ExaHelpers from "../exa_helpers";

export default class CandidateRateMission {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["CandidateRateMission"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        this.$missionUpdateRatingForm = $('#mission-update-rating-form');

        ExaHelpers.validation();
        this.initValidation();

        this.$missionUpdateRatingForm.on('click', '[type="submit"]', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            return ExaHelpers.submitAjaxFormWithButtons($form);
        }.bind(this));
    }

    initValidation() {
        this.$missionUpdateRatingForm.validate({
            ignore: [],
            rules: {
                'clarity_of_instructions_rating_id': {
                    required: true,
                },
                'allocated_time_rating_id': {
                    required: true,
                },
                'atmosphere_rating_id': {
                    required: true,
                },
            },
        });
    }

}

